<template>
  <HeaderTop></HeaderTop>
  <Header></Header>
  <!-- <NavHead :indexleftmenu="true"></NavHead> -->
  <NavHead :leftmenu="false"></NavHead>
  <div class="main">
    <div class="topbox">
      <div class="banner" v-if="bannerList.length != 0">
        <el-carousel trigger="click" :interval="3000">
          <el-carousel-item
            v-for="(item, index) in bannerList"
            :key="item.TBN_SEQ"
          >
            <img :src="item.TBN_PIC" @click="bannerPageTo(item.TBN_URL)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news" v-show="newsList.length != 0">
        <h2>
          头条信息
          <router-link to="/newslist" class="redw">MORE ></router-link>
        </h2>
        <ul>
          <router-link
            v-for="(item, index) in newsList"
            :key="item.TNM_ID"
            :to="'/newslist/' + item.TNM_ID + '&' + item.TNM_ORDER"
            target="_blank"
          >
            <li>{{ item.TTFL }} | {{ item.TNM_TITLE }}</li>
          </router-link>
        </ul>
      </div>
    </div>
    <div class="content">
      <div class="flexbox conbox conboxa">
        <div class="left">
          <h1>应用领域</h1>
          <div class="applicationbanner">
            <el-carousel trigger="click" :interval="4000" arrow="never">
              <el-carousel-item v-for="(item, index) in 1" :key="index">
                <img src="../assets/img/appbanner.jpg" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="right">
          <h1>
            新品机会
            <img src="../assets/img/newico.png" />
            <router-link
              :to="{
                name: 'GoodsList',
                query: { type: 'querymore', keywords: 'xptj' },
              }"
              class="grayw"
              >更多 ></router-link
            >
          </h1>
          <div class="newgoods">
            <ImgScroll :goodsimglist="newgoodslist"></ImgScroll>
          </div>
        </div>
      </div>
      <div
        class="flexbox conbox conboxb"
        v-if="leftShow && midShow && rightShow"
      >
        <div class="left">
          <h1>
            智能精选<router-link
              :to="{
                name: 'GoodsList',
                query: { type: 'querymore', keywords: 'zntj' },
              }"
              class="grayw"
              >更多 ></router-link
            >
          </h1>
          <div class="goodsbanner">
            <el-carousel
              :autoplay="true"
              interval="30000"
              arrow="hover"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, index) in goodslistL"
                :key="index"
              >
                <ul class="flexbox">
                  <li
                    v-for="it in item"
                    :key="it.TGN_ID"
                    @click="
                      pageToDetail(
                        it.MGM_GOODS_JPPZID,
                        it.MGM_GOODS_CZID,
                        it.MGM_GOODS_XSISSPLIT,
                        it.FIELD
                      )
                    "
                  >
                    <div><img :src="it.MGM_GOODSPIC_MAIN" /></div>
                    <p>{{ it.MGM_LONG_DESC }}</p>
                  </li>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="mid">
          <h1>
            常购清单<router-link
              :to="{
                name: 'GoodsList',
                query: { type: 'querymore', keywords: 'cgqd' },
              }"
              class="grayw"
              >更多 ></router-link
            >
          </h1>
          <div class="goodsbanner">
            <el-carousel
              :autoplay="true"
              interval="30000"
              arrow="hover"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, index) in goodslistM"
                :key="index"
              >
                <ul class="flexbox">
                  <li
                    v-for="it in item"
                    :key="it.TGN_ID"
                    @click="
                      pageToDetail(
                        it.MGM_GOODS_JPPZID,
                        it.MGM_GOODS_CZID,
                        it.MGM_GOODS_XSISSPLIT,
                        it.FIELD
                      )
                    "
                  >
                    <div><img :src="it.MGM_GOODSPIC_MAIN" /></div>
                    <p>{{ it.MGM_LONG_DESC }}</p>
                  </li>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="right">
          <h1>
            爆款推荐<router-link
              :to="{
                name: 'GoodsList',
                query: { type: 'querymore', keywords: 'bktj' },
              }"
              class="grayw"
              >更多 ></router-link
            >
          </h1>
          <div class="goodsbanner">
            <el-carousel
              :autoplay="true"
              interval="30000"
              arrow="hover"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, index) in goodslistR"
                :key="index"
              >
                <ul class="flexbox">
                  <li
                    v-for="it in item"
                    :key="it.TGN_ID"
                    @click="
                      pageToDetail(
                        it.MGM_GOODS_JPPZID,
                        it.MGM_GOODS_CZID,
                        it.MGM_GOODS_XSISSPLIT,
                        it.FIELD
                      )
                    "
                  >
                    <div><img :src="it.MGM_GOODSPIC_MAIN" /></div>
                    <p>{{ it.MGM_LONG_DESC }}</p>
                  </li>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="conbox conboxc">
        <h1>一站式产品</h1>
        <div class="flexbox">
          <div
            class="flexbox"
            v-for="item in dotpic"
            :key="item.TGO_ID"
            style="width: 50%"
          >
            <div class="left picpos" style="width: 100%">
              <img :src="item.TGO_URL" style="width: 100%" />
            </div>
          </div>
          <!-- <div class="midr picpos">
                        <img src="../assets/img/000.jpg">
                        <div class="point" style="top: 20px;left: 160px;">
                            <div class="dot"></div>
                            <p>部件说明</p>
                        </div>
                    </div>
                    <ul class="flexbox right">
                        <li v-for="(item, index) in 4" :key="index">
                            <div><img src="../assets/img/goods.png"></div>
                            <p>迈克球铁沟槽短型刚性卡箍</p>
                        </li>
                    </ul> -->
        </div>
      </div>
      <div class="conbox conboxd">
        <h1>玫德品牌</h1>
        <div class="flexbox bandbox">
          <div class="cell" v-for="item in brandList" :key="item.TBD_ID">
            <img :src="item.TBD_LOGO" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>Copyright© 2019 玫德集团有限公司 版权所有 鲁ICP备15010654号</p>
    </div>
  </div>
  <SideBar></SideBar>
  <SideNav></SideNav>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  getCurrentInstance,
} from "vue";
import { postReq } from "@/api/axios.js";
import config from "@/api/config.js";
import { useRouter } from "vue-router";
import { arrayDivide } from "@/util/util.js";
import HeaderTop from "@/components/headertop/HeaderTop";
import Header from "@/components/header/Header";
import NavHead from "@/components/navhead/NavHead";
import ImgScroll from "@/components/imgscroll/ImgScroll";
import SideBar from "@/components/sidebar/SideBar";
import SideNav from "@/components/sidenav/SideNav";

export default {
  name: "Index",
  components: {
    HeaderTop,
    Header,
    NavHead,
    ImgScroll,
    SideBar,
    SideNav,
  },
  setup(props, context) {
    let { proxy } = getCurrentInstance();
    let router = useRouter();
    let baseImgUrl = config.baseImgUrl;
    // 接口数据
    let pageData = reactive({
      bannerList: [], //轮播图
      newsList: [],
      newgoodslist: [],
      goodslistL: [],
      goodslistM: [],
      goodslistR: [],
      dotpic: [],
      brandList: [],
    });
    let productShow = reactive({
      leftShow: false,
      midShow: false,
      rightShow: false,
    });
    // 轮播图
    let getBanner = () => {
      let data = {
        postType: "querybanner",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.bannerList = res.items;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 轮播图跳转
    let bannerPageTo = (url) => {
      if (url != "") {
        router.push(url);
      }
    };
    // 头条信息
    let getNews = () => {
      let url = "/meide/REST/ajaxMdIndex";
      let data = {
        postType: "querytoutiao",
      };
      proxy.$axios
        .postReq(url, data)
        .then((res) => {
          if (res.success == "true") {
            res.items.map((item, index) => {
              if (index < 5) {
                pageData.newsList.push(item);
              }
            });
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 跳转新闻详情
    let gotoNews = (idx) => {
      // router.push({
      //     name: 'NewsDetail',
      //     param: {id: idx}
      // })
    };
    // 新品推荐
    let getNewgoods = () => {
      let url = "/meide/REST/ajaxMdIndex";
      let data = {
        postType: "querynewgoods",
      };
      proxy.$axios
        .postReq(url, data)
        .then((res) => {
          if (res.success == "true") {
            pageData.newgoodslist = res.items;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 智能精选
    let getGoodslistL = () => {
      let data = {
        postType: "queryzngoods",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.goodslistL = arrayDivide(res.items, 4);
            productShow.leftShow = true;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 常购清单
    let getGoodslistM = () => {
      let data = {
        postType: "querycggoods",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.goodslistM = arrayDivide(res.items, 6);

            productShow.midShow = true;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 爆款推荐
    let getGoodslistR = () => {
      let data = {
        postType: "querybkgoods",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.goodslistR = arrayDivide(res.items, 6);
            productShow.rightShow = true;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 一站式产品
    let getDotpicList = () => {
      let data = {
        postType: "queryoneclass",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            res.items.map((item) => {
              item.TGO_URL = config.icoBaseUrl + item.TGO_URL;
            });
            pageData.dotpic = res.items;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 品牌
    let getBrandList = () => {
      //   proxy.$axios.postReq('/meide/REST/ajaxMdIndex', {
      //       postType:'querybrandwall'
      //   }).then(res=>{

      //   })

      let data = {
        postType: "querybrand",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            res.items.map((item) => {
              item.TBD_LOGO = config.icoBaseUrl + item.TBD_LOGO;
            });
            pageData.brandList = res.items;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };

    // 跳转产品详情
    let pageToDetail = (pz, cz, xs, field) => {
      router.push({
        name: "ProductDetails",
        query: {
          pz: pz,
          cz: cz,
          xs: xs,
          field: field,
        },
      });
    };
    //获取欠款信息  (暂时不用)
    // let getQiankuan = () => {
    //   proxy.$axios
    //     .postReq("/meide/REST/ajaxOrderInfo", {
    //       postType: "queryPayType",
    //     })
    //     .then((res) => {
    //       console.log(res);
    //     });
    // };
    onBeforeMount(() => {
    //   getQiankuan(); //用户的欠款信息     ajaxOrderInfo.dox?postType=queryPayType
      getBanner();
      getNews();
      getNewgoods();
      getGoodslistL();
      getGoodslistM();
      getGoodslistR();
      getBrandList();
      getDotpicList();
    });
    return {
      ...toRefs(pageData),
      ...toRefs(productShow),
      getBanner,
      bannerPageTo,
      getNews,
      gotoNews,
      getNewgoods,
      getGoodslistL,
      getGoodslistM,
      getGoodslistR,
      getBrandList,
      pageToDetail,
    };
  },
};
</script>

<style scoped lang="scss">
.main {
}
.topbox {
  width: 1200px;
  margin: auto;
  position: relative;
  .banner {
    ::v-deep(.el-carousel__container) {
      height: 354px;
    }
  }
  .news {
    background: rgba(255, 255, 255, 0.6);
    padding: 20px 15px;
    position: absolute;
    top: 45px;
    right: 65px;
    z-index: 50;
    border-radius: 10px;
    h2 {
      font-size: 16px;
      margin-bottom: 20px;
      a {
        font-size: 12px;
        float: right;
        color: #ad101d;
      }
    }
    ul {
      height: 150px;
      a {
        display: block;
        li {
          width: 180px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 12px;
          font-size: 12px;
          cursor: pointer;
          color: #000;
        }
      }

      li:hover {
        color: #ad101d;
      }
    }
  }
}
.content {
  width: 1200px;
  margin: auto;
  .flexbox {
    align-items: flex-start;
  }
  .conbox {
    background: #fff;
    h1 {
      font-size: 20px;
      font-weight: bolder;
      padding: 10px;
      a {
        float: right;
        padding-top: 5px;
      }
      a:hover {
        color: #f42434;
      }
    }
    .left {
    }
    .right {
    }
  }
  .conboxa {
    border-bottom: 10px solid #f3f3f3;
    .left {
      border-right: 10px solid #f3f3f3;
      .applicationbanner {
        ::v-deep(.el-carousel__container) {
          height: 200px;
        }

        width: 300px;
        height: 200px;
        img {
          width: 300px;
          height: 200px;
        }
      }
    }
    .right {
      .newgoods {
      }
    }
  }
  .conboxb {
    border-bottom: 10px solid #f3f3f3;
    ::v-deep(.el-carousel__container) {
      height: 360px;
    }
    ul {
      flex-wrap: wrap;
      li {
        width: 146px;
        height: 180px;
        text-align: center;
        border-bottom: 2px solid #f3f3f3;
        cursor: pointer;
        div {
          width: 140px;
          padding: 5px;
          img {
            width: 100px;
            height: 100px;
          }
        }
        p {
          padding: 2px;
          font-size: 12px;
          text-align: center;
          height: 48px;
          overflow: hidden;
        }
      }
    }
    .left {
      width: 300px;
      li {
        width: 150px;
        &:nth-child(even) {
          border-left: 2px solid #f3f3f3;
        }
      }
    }
    .mid {
      width: 460px;
      border-right: 10px solid #f3f3f3;
      border-left: 10px solid #f3f3f3;
      li {
        border-right: 2px solid #f3f3f3;
        &:nth-child(3n) {
          border-right: 2px solid #fff;
        }
      }
    }
    .right {
      width: 440px;
      li {
        border-right: 2px solid #f3f3f3;
        &:nth-child(3n) {
          border-right: 2px solid #fff;
        }
      }
    }
  }
  .conboxc {
    border-bottom: 10px solid #f3f3f3;
    padding-bottom: 20px;
    ul {
      flex-wrap: wrap;
      justify-content: space-around;
      li {
        width: 146px;
        height: 150px;
        text-align: center;
        border-bottom: 2px solid #f3f3f3;
        &:nth-child(even) {
          border-left: 2px solid #f3f3f3;
        }
        div {
          width: 140px;
          padding: 5px;
          img {
            width: 60%;
          }
        }
        p {
          padding: 10px 5px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .picpos {
      position: relative;
      width: 300px;
      height: 300px;
      img {
        width: 300px;
        height: 300px;
      }
      .point {
        position: absolute;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 23px;
        background: #fff;
        width: 23px;
        border-radius: 200px;
        border: 2px solid #eee;
        box-sizing: content-box;
        cursor: pointer;
        .dot {
          width: 19px;
          height: 19px;
          border-radius: 200px;
          background: rgb(0, 144, 111);
        }
        p {
          margin-left: 5px;
          font-size: 12px;
          display: none;
        }
        &:hover {
          justify-content: flex-start;
          padding: 0 2px;
          width: 90px;
          p {
            display: block;
          }
        }
      }
    }
    .left {
    }
    .midl {
      li {
      }
    }
    .midr {
    }
    .right {
      li {
      }
    }
  }
  .conboxd {
    h1 {
      border-bottom: 3px solid #f42434;
    }
    .bandbox {
      flex-wrap: wrap;
      .cell {
        /* border: 1px solid #f3f3f3; */
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
.footer {
  margin-top: 70px;
  background: #e4e4e4;
  padding: 40px 0;
  p {
    text-align: center;
    color: #333;
  }
}
</style>